import { Component, Vue } from "vue-property-decorator";
import UlContentHeader from "@/components/UlContentHeader.vue";
import UlBreadcrumbs from "@/components/UlBreadcrumbs.vue";
import service from "@/api/service";
import StripeConfirmGet from "@/store/stripe-confirm/get";

@Component({
  components: { UlContentHeader, UlBreadcrumbs }
})
export default class Confirm extends Vue {
  // ------------
  // 固定値
  // ------------
  // タイトル
  headingMain = "Stripe";
  headingSub = "stripe";
  breadCrumbs = [{ text: "設定 > Stripe > Stripe確認", disabled: true }];

  result = 0;

  // ------------
  // 変動値
  // ------------

  // ローディングステータス
  isLoading = false;

  /**
   * createdライフサイクルフック
   */
  async created() {
    await StripeConfirmGet.get({shop_id: this.$route.params.shopId});
    if (StripeConfirmGet.isSuccess && StripeConfirmGet.getResults.status) {
        this.result = StripeConfirmGet.getResults.status;
    } else {
        this.result = 3;
    }
  }

  /**
   * beforeDestroyライフサイクルフック
   */
  async beforeDestroy() {
    await StripeConfirmGet.clearResponse();
  }
}
